import {
  CarePlanBirthSex,
  CarePlanChatRequest,
  CarePlanItem,
  CarePlanItemTriggerType,
  CarePlanItemType,
  CarePlanMilestone,
  CarePlanOpenLinkBehavior,
  CarePlanReading,
} from '@summer-health/types/care-plan';
import { CareTeamRole } from '@summer-health/types/care-team';

type AnyCarePlanItem =
  | CarePlanReading
  | CarePlanMilestone
  | CarePlanChatRequest;

const readSleep2w: CarePlanReading = {
  carePlanItemId: 'read_sleep_2w',
  type: CarePlanItemType.READING,
  overline: 'Recommended Reading',
  title: 'Learn about baby sleep patterns',
  primaryCTA: 'Read now',
  primaryCTAURL:
    'https://docs.google.com/presentation/d/1X7WWghgnR5CsMJpMk6ex0oYPLQEZHwXSMG99FM0W0OY/edit?usp=sharing',
  triggerType: CarePlanItemTriggerType.AGE,
  triggerValueInDays: 12,
  birthSex: CarePlanBirthSex.ANY,
  openLinkBehavior: CarePlanOpenLinkBehavior.SELF,
  icon: 'user',
  tags: [],
};

const readMilestones1m: CarePlanMilestone = {
  carePlanItemId: 'read_milestones_1m',
  type: CarePlanItemType.MILESTONE,
  overline: 'Upcoming Milestones',
  title: '1 month!',
  primaryCTA: 'View milestones',
  primaryCTAURL: '/milestones/1-month',
  triggerType: CarePlanItemTriggerType.AGE,
  triggerValueInDays: 36,
  birthSex: CarePlanBirthSex.MALE,
  tags: [],
};

const visitEdc2w: CarePlanChatRequest = {
  carePlanItemId: 'visit_EDC_2w',
  type: CarePlanItemType.CHAT_REQUEST,
  overline: 'Suggested Visit',
  title: 'Check in with your pediatrician',
  primaryCTA: 'Chat request',
  triggerType: CarePlanItemTriggerType.AGE,
  triggerValueInDays: 14,
  birthSex: CarePlanBirthSex.FEMALE,
  careTeamRole: CareTeamRole.Pediatrician,
  tags: [],
};

const visitEdc1m: CarePlanChatRequest = {
  carePlanItemId: 'visit_EDC_1m',
  type: CarePlanItemType.CHAT_REQUEST,
  overline: 'Suggested Visit',
  title: 'Check in with your pediatrician',
  primaryCTA: 'Chat request',
  triggerType: CarePlanItemTriggerType.AGE,
  triggerValueInDays: 30,
  birthSex: CarePlanBirthSex.ANY,
  careTeamRole: CareTeamRole.Pediatrician,
  specifiedProviderId: 'provider_abcd',
  tags: [],
};

export const carePlanItems: Record<string, AnyCarePlanItem> = {
  [readSleep2w.carePlanItemId]: readSleep2w,
  [readMilestones1m.carePlanItemId]: readMilestones1m,
  [visitEdc2w.carePlanItemId]: visitEdc2w,
  [visitEdc1m.carePlanItemId]: visitEdc1m,
};

export const carePlanItemsAsBaseList: CarePlanItem[] =
  Object.values(carePlanItems);
